/* RESPONSIBLE TEAM: team-workflows */
import EditorConfig from 'embercom/objects/content-editor/content-editor-configuration';
import generateViewModeConfig from 'embercom/objects/content-editor/configuration-generators/triggerable-custom-bot/view-mode-generator';
import generateEditModeConfig from 'embercom/objects/content-editor/configuration-generators/triggerable-custom-bot/edit-mode-generator';
import generateNotificationMessages from 'embercom/objects/content-editor/configuration-generators/standard-notification-messages-generator';
import generateBotNotificationMessages from 'embercom/objects/content-editor/configuration-generators/triggerable-custom-bot/notification-messages-generator';
import { objectTypes } from 'embercom/models/data/matching-system/matching-constants';
import { humanReadableObjectNames } from 'embercom/models/data/matching-system/matching-constants';

export default function generateEditorConfig(options) {
  options.objectType = objectTypes.triggerableCustomBot;
  let container = options.container;
  let customBot = options.customBot;
  let intl = container.lookup('service:intl');
  let humanReadableObjectName = humanReadableObjectNames[options.objectType];
  let notificationMessages = generateNotificationMessages(options);
  let botNotificationMessages = generateBotNotificationMessages(container, humanReadableObjectName);
  notificationMessages.activate = botNotificationMessages.activate;
  notificationMessages.deactivate = botNotificationMessages.deactivate;
  notificationMessages.delete = botNotificationMessages.delete;
  notificationMessages.save = botNotificationMessages.save;
  notificationMessages.saveAsDraft = botNotificationMessages.saveAsDraft;
  notificationMessages.discardDraft = botNotificationMessages.discardDraft;
  notificationMessages.discardDraftPaused = botNotificationMessages.discardDraftPaused;
  notificationMessages.schedule = botNotificationMessages.schedule;

  let paywallUpgradeHoverCopy = 'operator.custom-bot.header.set-live-paywall-text-with-workflows';

  return EditorConfig.create({
    viewMode: generateViewModeConfig(options),
    editMode: generateEditModeConfig(options),
    notificationMessages,
    requiredFeature: customBot.config.requiredBillingFeature,
    paywallHoverParams: {
      customFeatureText: intl.t(paywallUpgradeHoverCopy),
    },
  });
}
